// const BASE_URL = 'http://localhost:8080'; 

const BASE_URL = 'https://deltaen.in'; 



export { BASE_URL};
